import { InvestmentEntity } from '../../../models/InvestmentEntity';
import Investor from '../../../models/Investor';
import { InvestmentAllocation } from '../../../models/InvestmentEntity';
import { saveEntityAllocation } from './adminEntityAssociationWizardActions';

export async function persistEntityAllocation(
  investor: Investor,
  entity: InvestmentEntity,
  allocatedAmount: number,
  currentAllocations: InvestmentAllocation[] = [],
): Promise<boolean> {
  return saveEntityAllocation(investor, entity, allocatedAmount, currentAllocations);
}

export function allocationSuccessMessage(wasUpdate: boolean): string {
  return wasUpdate
    ? 'Investment entity allocation updated successfully'
    : 'Investment entity associated with allocated amount successfully';
}
